import React, { useState } from 'react'
import './ProcessHub.scss';
import SideBar from './sideBar/SideBar';
import Detail from './details/Detail';
import { useLocation } from 'react-router-dom';

function ProcessHub() {
    const location = useLocation();
    const initialData = location.state?.initialData || {};
    const [selectedDept, setSelectedDept] = useState(initialData || {});

    return (
        <div className="hubContainer">
            <div className="row" style={{marginTop: '0px'}}>
                <div className="col-md-3 sidebar">
                    <SideBar selectedDept={selectedDept} setSelectedDept={setSelectedDept} />
                </div>
                <div className="col-md-9 bg-light p-3">
                    <Detail selectedDept={selectedDept} />
                </div>
            </div>
        </div>
    )
}

export default ProcessHub